export interface ResourceFilter {
  search: string;
  status: string;
  type: string;
}

export const createDefaultFilter = (): ResourceFilter => ({
  search: '',
  status: '',
  type: '',
});
